import cx from 'classnames';
import PropTypes from 'prop-types';

import './index.less';

function Sider({ collapsed, children }) {
  return (
    <div
      className={cx('layout__sider', {
        'layout__sider--collapsed': collapsed
      })}
    >
      {children}
    </div>
  );
}

Sider.propTypes = {
  collapsed: PropTypes.bool,
  children: PropTypes.node,
};

export default Sider;
